const getCrypto = () => (typeof globalThis === "undefined" ? undefined : globalThis.crypto);

const bytesToUuid = (bytes: Uint8Array) => {
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));

    return [
        hex.slice(0, 4).join(""),
        hex.slice(4, 6).join(""),
        hex.slice(6, 8).join(""),
        hex.slice(8, 10).join(""),
        hex.slice(10, 16).join(""),
    ].join("-");
};

export const generateUuid = () => {
    const cryptoObject = getCrypto();

    if (typeof cryptoObject?.randomUUID === "function") {
        return cryptoObject.randomUUID();
    }

    const bytes = new Uint8Array(16);

    if (typeof cryptoObject?.getRandomValues === "function") {
        cryptoObject.getRandomValues(bytes);
    } else {
        bytes.forEach((_, index) => {
            bytes[index] = Math.floor(Math.random() * 256);
        });
    }

    return bytesToUuid(bytes);
};
